import { Enums } from "@moe/priv/types/sb-types";
import { SubscriptionKind, SubscriptionTier } from "@moe/priv/types/types";
import { DeepPartial } from "react-hook-form";

export const profileConfig = {
  usernameMinChars: 1,
  usernameMaxChars: 25,
  usernameRegex: /^[a-zA-Z0-9_-]+$/,

  bioMinChars: 0,
  bioMaxChars: 256,

  avatarWidth: 400,
  avatarHeight: 600,
  avatarMaxFileSizeBytes: 1e6,

  bannerWidth: 1500,
  bannerHeight: 500,
  bannerMaxFileSizeBytes: 1e6
};

export type Badge = Enums<"profilebadgekind">;

export interface Profile {
  id: string;
  username: string;
  bio: string;
  badges: Badge[];
  createdAt: string;
  avatar?: string;
  banner?: string;
  followerCount: number;
  followingCount: number;
  messageCount: number;
  followers: string[];
  following: string[];
  isFollowing: boolean;
}

export interface ProfileSettings {
  nsfwOK: boolean;
  confirmDelete: boolean;
  messageAvatarSize: Enums<"messageavatarsize">;
  messageAvatarShape: Enums<"messageavatarshape">;
  blacklistedTags: string[];
  blockquoteMode: boolean;
}

// Contains extra data that's private to each user
export interface ProfileSelf {
  id: string;
  username: string;
  bio: string;
  badges: Badge[];
  createdAt: string;
  avatar?: string;
  banner?: string;
  followerCount: number;
  followingCount: number;
  messageCount: number;
  followers: string[];
  following: string[];
  subscriptions: Subscription[];
  settings: ProfileSettings;
}

export interface Subscription {
  kind: SubscriptionKind;
  tier: SubscriptionTier;
}

export interface ProfileUpdate {
  id?: string;
  username?: string;
  bio?: string;
  avatar?: File;
  banner?: File;
  settings?: Partial<ProfileSettings>;
}
